const gitinfo = {
  "commit": "3f8d146639f97435768a9fc73423a6402e811f18",
  "abbreviated_commit": "3f8d146",
  "tree": "a24cc37569bd6e2bca6e4be62f78750638fdeb7d",
  "abbreviated_tree": "a24cc37",
  "parent": "a6ae21b989425a475f4ddb378c060d1a49b84404",
  "abbreviated_parent": "a6ae21b",
  "refs": "HEAD -> main, origin/main, origin/HEAD",
  "encoding": "",
  "commit_notes": "",
  "verification_flag": "N",
  "signer": "",
  "signer_key": "",
    "date": "Sat, 24 May 2025 10:40:55 -0500"
 }
export default gitinfo;